import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Card, CardBody, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, Spinner, TabContent, Table, TabPane, UncontrolledDropdown } from 'reactstrap';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

//SimpleBar
import SimpleBar from "simplebar-react";

//import images
import avatar10 from "../../../../../assets/images/users/avatar-10.jpg";
import avatar8 from "../../../../../assets/images/users/avatar-8.jpg";
import avatar2 from "../../../../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../../../assets/images/users/avatar-4.jpg";
import avatar7 from "../../../../../assets/images/users/avatar-7.jpg";
import { ODataGrid } from '../../../../../Components/OElements/ODataGrid';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getEvidenceList } from '../../../../../slices/thunks';
import { mimeTypeToIconMapping } from '../../../../../helpers/mime-type_to_icon';
import { filesize } from 'filesize';
import UploadEvidenceModal from '../../Modals/Evidence/UploadEvidenceModal';
import {
	downloadFile as onDownloadFile,
} from '../../../../../slices/thunks';
import ReviewEvidenceModal from '../../Modals/Evidence/ReviewEvidenceModal';
import { cleanItemEvidencesList } from '../../../../../slices/evidence/reducer';

const Comments = ({ data }) => {
    const [activeTab, setActiveTab] = useState('files');
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const status_available_review = ['CRG', 'RVS'];

    const dispatch = useDispatch();

    const selector = createSelector(
        state => state.Evidences,
        evidences => ({
            evidencesList: evidences.itemEvidenceList,
            isLoading: evidences.isLoading,
            isSuccess: evidences.isSuccess,
            isError: evidences.isError,
        })
    );

	const { evidencesList, isLoading, isSuccess, isError } = useSelector(selector);

    const [dataEvidence, setDataEvidence] = useState(null);
    
	useEffect(() => {
		dispatch(getEvidenceList({ activity_id: data._id }));
	}, [dispatch]);

    useEffect(() => {
        return () => {
            dispatch(cleanItemEvidencesList());
        }
    }, [])

	const [modalUploadEvidence, setModalUploadEvidence] = useState(false);
    const [modalReviewEvidence, setModalReviewEvidence] = useState(false);
    
    function handleToggleModalUploadEvidence() {
		setModalUploadEvidence(!modalUploadEvidence);
	}

    function handleToggleModalReviewEvidence() {
		setModalReviewEvidence(!modalReviewEvidence);
	}

    const handleClickUploadEvidence = () => {
		handleToggleModalUploadEvidence();
	};

    const handleClickReviewEvidence = (data) => {
        setDataEvidence(data);
		handleToggleModalReviewEvidence();
	};

    const [fileDownloadLoading, setFileDownloadLoading] = useState(null);
    
    const [sidebarData, setSidebarData] = useState("");

    const columns = useMemo(
        () => [
            {
                header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
                accessorKey: 'guide',
                columnDefType: 'display',
                
                size: 'auto',
                Cell: cellProps => {
                    const { evidence_status } = cellProps.row.original;
                    return (
                        <React.Fragment>
                            <div className='d-flex'>
                                <div className='flex-shrink-0'>
                                    <ul className='list-inline mb-0'>
                                        <li className='list-inline-item'>
                                            <Link
                                                title={'Descargar'}
                                                to='#'
                                                onClick={e => {
                                                    e.preventDefault();
                                                    setFileDownloadLoading(
                                                        cellProps.row.original.document[0]._id
                                                    );
                                                    dispatch(
                                                        onDownloadFile({
                                                            file_id:
                                                                cellProps.row.original.document[0]._id,
                                                        })
                                                    )
                                                        .then(data => {
                                                            const payload = data.payload;
                                                            const url =
                                                                window.URL.createObjectURL(
                                                                    payload
                                                                );
                                                            const link =
                                                                document.createElement('a');
                                                            link.href = url;
                                                            link.setAttribute(
                                                                'download',
                                                                `${cellProps.row.original.document[0].filename}${cellProps.row.original.document[0].extension}`
                                                            );
                                                            document.body.appendChild(link);
                                                            link.click();
                                                        })
                                                        .finally(() =>
                                                            setFileDownloadLoading(null)
                                                        );
                                                }}
                                            >
                                                <i className='ri-download-fill align-bottom me-2 text-muted' />
                                            </Link>
                                        </li>
                                        <li className='list-inline-item'>
                                            <Link
                                                title={'Ver'}
                                                to='#'
                                                onClick={e => {
                                                    e.preventDefault();
                                                    setSidebarData(cellProps.row.original.document);
                                                    fileSidebar();
                                                    sidebarOpen('file-detail-show');
                                                }}
                                            >
                                                <i className='ri-eye-fill align-bottom me-2 text-muted' />
                                            </Link>
                                        </li>
                                        <li className='list-inline-item'>
                                            <Link
                                                title='Revisar'
                                                to='#'
                                                onClick={e => {
                                                    e.preventDefault();
                                                    // if(status_available_review.includes(evidence_status.code)){
                                                        handleClickReviewEvidence(cellProps.row.original);
                                                    // }
                                                }}
                                            >
                                                <i className={`ri-draft-fill align-bottom me-2 text-muted ${(!status_available_review.includes(evidence_status.code)) ? 'opacity-50' : ''}`} />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                },
            },
            {
                header: 'Nombre',
                accessorKey: 'filename',
                filterVariant: 'autocomplete',
                Cell: cellProps => {
                    return (
                        <div className='d-flex align-items-center'>
                            <div className='flex-shrink-0 fs-13 me-2 filelist-icon'>
                                <i
                                    className={
                                        mimeTypeToIconMapping[
                                            cellProps.row.original.document[0].mime_type
                                        ].icon +
                                        '-fill' +
                                        ' align-bottom'
                                    }
                                    style={{
                                        color: mimeTypeToIconMapping[
                                            cellProps.row.original.document[0].mime_type
                                        ].color,
                                    }}
                                />
                            </div>
                            <div className='flex-grow-1 filelist-name'>
                                {cellProps.row.original.document[0].filename}
                                {cellProps.row.original.document[0].extension}
                            </div>
                        </div>
                    );
                },
            },
            // {
            //     header: 'Tipo',
            //     accessorKey: 'file_type',
            //     
            //     size: 'auto',
            //     Cell: ({ row }) => {
            //         return row?.original.document[0].file_type?.length
            //             ? row.original.document[0].file_type[0].name
            //             : '';
            //     },
            // },
            // {
            //     header: 'Importante',
            //     accessorKey: 'isFavourite',
            //     Cell: cellProps => {
            //         return (
            //             <div className='d-flex justify-content-center'>
            //                 <button
            //                     type='button'
            //                     className={`btn btn-ghost-primary btn-icon btn-sm favourite-btn ${cellProps.row.original.document[0].isFavourite ? 'active' : ''
            //                         }`}
            //                     onClick={e =>
            //                         favouriteBtn(e.target, cellProps.row.original.document[0]._id)
            //                     }
            //                 >
            //                     <i className='ri-star-fill align-bottom me-2 text-muted' />
            //                 </button>
            //             </div>
            //         );
            //     },
            // },
            {
                header: 'Estado',
                accessorKey: 'evidence_status.name',
                
                width: 10,
                Cell: ({ row }) => {
                    const { bgcolor, txcolor, icon, name } = row.original.evidence_status || {};
                    return (
                        <div className='d-flex align-items-center'>
                            {name && (
                                <span className='badge' style={{ backgroundColor: bgcolor, color: txcolor }}>
                                    <i className={`align-middle ${icon}`}></i> {name}
                                </span>
                            )}
                        </div>
                    );
                },
            },
            {
                header: 'Tamaño',
                accessorKey: 'size',
                Cell: cellProps => {
                    return (
                        <div className='filelist-size'>
                            {filesize(cellProps.row.original.document[0].size || 0)}
                        </div>
                    );
                },
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <Card>
                <CardHeader>
                    <div>
                        <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
                            <NavItem>
                                <NavLink
                                    href="#"
                                    className={classnames({ active: activeTab === 'files' })}
                                    onClick={() => { toggleTab('files'); }}
                                >
                                    Evidencias Cargadas <span className="badge bg-primary ms-1">{evidencesList.length}</span>
                                    
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href="#"
                                    className={classnames({ active: activeTab === 'comments' })}
                                    onClick={() => { toggleTab('comments'); }}
                                >
                                    Comentarios <span className="badge bg-primary ms-1">{evidencesList.length}</span>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href="#"
                                    className={classnames({ active: activeTab === 'history' })}
                                    onClick={() => { toggleTab('history'); }}
                                >
                                    Historial
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </div>
                </CardHeader>
                <CardBody>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId='comments'>
                            <h5 className="card-title mb-4">Comentarios</h5>
                            <SimpleBar style={{ height: "400px" }} className="px-3 mx-n3 mb-2">
                                <div className="d-flex mb-4">
                                    <div className="flex-shrink-0">
                                        <img src={avatar10} alt="" className="avatar-xs rounded-circle" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                        <h6 className="mb-1">
                                            Rosita Retamal
                                            <small className="text-muted"> 23 Ago 2024 - 09:15AM</small>
                                        </h6>
                                        <p className="text-muted">
                                            He revisado el documento y he encontrado algunas observaciones que podrían mejorarse antes de la entrega final.
                                        </p>
                                        <Link to="#" className="badge text-muted bg-light">
                                            <i className="mdi mdi-reply"></i> Responder
                                        </Link>
                                        <div className="d-flex mt-4">
                                            <div className="flex-shrink-0">
                                                <img src={avatar8} alt="" className="avatar-xs rounded-circle" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h6 className="mb-1">
                                                    Juan Pablo López
                                                    <small className="text-muted"> 23 Ago 2024 - 10:30AM</small>
                                                </h6>
                                                <p className="text-muted">
                                                    Buenas conclusiones, Rosita. Sin embargo, creo que falta incluir el gráfico de la página 4 para darle más contexto.
                                                </p>
                                                <Link to="#" className="badge text-muted bg-light">
                                                    <i className="mdi mdi-reply"></i> Responder
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex mb-4">
                                    <div className="flex-shrink-0">
                                        <img src={avatar2} alt="" className="avatar-xs rounded-circle" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                        <h6 className="mb-1">
                                            Margarita Muñoz
                                            <small className="text-muted"> 23 Ago 2024 - 11:45AM</small>
                                        </h6>
                                        <p className="text-muted">
                                            Estoy de acuerdo con las observaciones. También creo que se podría mejorar la redacción en el apartado de conclusiones para que sea más claro.
                                        </p>
                                        <Link to="#" className="badge text-muted bg-light">
                                            <i className="mdi mdi-reply"></i> Responder
                                        </Link>
                                    </div>
                                </div>

                                <div className="d-flex">
                                    <div className="flex-shrink-0">
                                        <img src={avatar8} alt="" className="avatar-xs rounded-circle" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                        <h6 className="mb-1">
                                            Juan Pablo López
                                            <small className="text-muted"> 23 Ago 2024 - 01:00PM</small>
                                        </h6>
                                        <p className="text-muted">
                                            Entendido, voy a incluir el gráfico y revisar la redacción. Gracias a ambas por sus comentarios.
                                        </p>
                                        <Link to="#" className="badge text-muted bg-light">
                                            <i className="mdi mdi-reply"></i> Responder
                                        </Link>
                                    </div>
                                </div>
                            </SimpleBar>


                            <form className="mt-4">
                                <Row className="g-3">
                                    <Col lg={12}>
                                        <label htmlFor="exampleFormControlTextarea1" className="form-label">Dejar un comentario</label>
                                        <textarea className="form-control bg-light border-light" id="exampleFormControlTextarea1" rows="3" placeholder="Ingresar comentario"></textarea>
                                    </Col>
                                    <Col xs={12} className="text-end">
                                        <button type="button" className="btn btn-ghost-secondary btn-icon waves-effect me-1"><i className="ri-attachment-line fs-16"></i></button>
                                        <Link to="#" className="btn btn-success">Comentar</Link>
                                    </Col>
                                </Row>
                            </form>
                        </TabPane>
                        <TabPane tabId='files'>
                            <React.Fragment>
                                <Row className="mb-3 pb-1">
                                    <Col xs={12}>
                                        <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                                            <div className="flex-grow-1">
                                            </div>
                                            <div className="mt-3 mt-lg-0">
                                                <form action="#">
                                                    <Row className="g-3 mb-0 align-items-center">
                                                        <div className="col-auto">
                                                            <button
                                                                type="button"
                                                                className="btn btn-label btn-primary"
                                                                onClick={() => {
                                                                    handleClickUploadEvidence()
                                                                }}
                                                            >
                                                                <i className={`${Icons.plus} label-icon`}></i> Agregar Evidencia
                                                            </button>
                                                        </div>
                                                    </Row>
                                                </form>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </React.Fragment>
                            <ODataGrid
                                columns={columns}
                                data={evidencesList || []}
                                isLoadingData={isLoading}
                            />
                        </TabPane>
                    </TabContent>
                </CardBody>
            </Card>
            <UploadEvidenceModal
				data={data}
				isOpen={modalUploadEvidence}
				handleToggleModal={handleToggleModalUploadEvidence}
				activeTab={activeTab}
				toggleTab={toggleTab}
				showDetails={false}
			/>
            <ReviewEvidenceModal
				data={data}
                dataEvidence={dataEvidence}
				isOpen={modalReviewEvidence}
				handleToggleModal={handleToggleModalReviewEvidence}
				activeTab={activeTab}
				toggleTab={toggleTab}
				showDetails={false}
			/>
        </React.Fragment>
    );
};

export default Comments;